module.exports = __webpack_public_path__ + "static/media/menu.5136f7ac.svg";